import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { TiFolderOpen } from 'react-icons/ti';
import { grey } from '@mui/material/colors';

const UploadModern = ({ uploadText, getRootProps, getInputProps, height }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                '& ul': {
                    listStyle: 'none',
                    padding: 0,
                },
                height: height
            }}
        >
            <Box
                {...getRootProps}
                sx={{
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: (theme) => `dashed 2px ${theme.palette.divider}`,
                    borderRadius: 2.5,
                    p: 5,
                    textAlign: 'center',
                    mb: 4,
                    color: 'text.secondary',
                    backgroundColor: grey[100],
                }}
            >
                <input {...getInputProps} />
                <TiFolderOpen
                    style={{
                        fontSize: 60,
                        marginBottom: 4,
                        color: grey[500],
                    }}
                />
                <p>{uploadText}</p>
            </Box>
            <span>*) Hanya pdf yang akan diterima dan ukuran file maks 50 MB</span>
        </Box>
    );
};

export default UploadModern;

UploadModern.propTypes = {
    uploadText: PropTypes.string,
    getRootProps: PropTypes.func,
    getInputProps: PropTypes.func,
    height: PropTypes.string
};
